import ToastContainer from "@components/ui/toast/ToastContainer";

const ToastProvider = () => {
  const positions = [
    "top-left",
    "top-right",
    "bottom-left",
    "bottom-right",
    "top-center",
    "bottom-center",
  ];

  return (
    <>
      {positions.map((position) => (
        <ToastContainer key={position} position={position} />
      ))}
    </>
  );
};

export default ToastProvider;
